// ToDO: ALL THIS FROM HERE TO THE LINE OF "-" NEEDS TO BE MOVED TO THE BACKEND
/*
 * Case Type constants to avoid using magic strings in components.
 * The ids from the server should stay the same
 * (safer to use these rather than labels which may change)
 */
import {DEFAULT_GUID} from './app/services/forms/case-form/case-form.service';

export enum CaseTypeIdEnum {
  General = 'a0454696-0660-4951-b5a1-12f021c6a474',
  CrimeVictim = '89e9c662-54d9-4685-bbe0-c299e46ffba7'
}

/**
 * Selection dropdown default values that are represented by an id.
 */
export enum DropDownDefaultValues {
  Age = 'aded77cc-4511-44e9-ab9f-80ca5b3740af',
  Race = '98304130-0b11-482f-b6d2-97941a461daf',
  Gender = '126c6749-4b12-4a6b-9a63-17b88ea397a7',
}

/**
 * Claim Type ID Enums
 * ToDo: To be replaced with Ryan's backend enums
 */
export enum ClaimTypeIdEnum {
  None = 'null',
  PersonalInjury = '17df51db-5f6a-446d-9c6c-f5870e1923c5',
  WrongfulDeath = 'f98626f1-082e-43c7-87f3-fef28fac0560',
  Prisoner = '5acbb51b-0c60-4713-9e6c-38b733b45a98',
  Contract = 'ce937583-fd84-433a-853f-8719080be0ee',
  LapsedAppropriation = '7e8457ee-3373-41db-a3cb-ff9a1a039dcf',
  BackSalary = '3ea9f75a-b673-4c13-9fe9-2f8148c37515',
  LostWarrant = 'df57b345-0768-4442-a98e-686a83023ed5',
  ReimbursementClaim = '14a1eaf8-d0ee-4b6d-b267-5c33fd362033',
  PropertyDamage = 'b575e8c6-a9d0-4699-9032-a7ad90617091',
  Miscellaneous = '6220ea6e-2296-48b3-b959-0a764df09f57',
  LineOfDutyCompensation = '195d57d9-ec71-4726-81d5-856ada3cee8e',
  PoliceFireNatGuard = '195d57d9-ec71-4726-81d5-856ada3cee8e',
  MedicalVendor = '34f24f91-8a22-4e84-a88a-84b50eb5b8ee',
  CertificateOfInnocence = '47053200-5e0d-4828-9ab7-5575c91ed23f',
}

/**
 * Document Type ID Enums
 * ToDo: 2/12/2025 - Need to replace with Ryan's backend enums
 */
export const enum DocumentTypeIdEnum {
  Complaint = '996b22f0-48af-4050-b1a7-d3d43e9d12fb',
  ComplaintAmendedComplaint = '3b95dae5-fea4-4072-a54b-fb203f79b0c5',
  ComplaintChangeOfAddress = '2574f85d-cadb-4707-b6c7-edd5824be15d',
  ClaimantMotionForSummaryJudgment = 'bbf73e93-e1e7-476e-8484-f79ae89fa6ef',
  ClaimantMotionToDismiss = '2bd70af7-86ad-4925-bbbd-93078afd1187',
  ClaimantAttorneyMotionToWithdrawFromClaim = '553a60c5-4043-45a3-83df-80eba7917ef6',
  ClaimantMotionToWithdrawClaim = 'b261a765-9e38-4584-884b-9da05bd7a0f7',
  ClaimantPaymentInformation = '401726cb-cf33-4be8-8c82-037b9c75f402',
  ClaimantMotionToPlaceClaimOnGeneralContinuance = '0798f820-cde8-44c8-8ef1-a802616849a7',
  ClaimantAnnualStatusReportToAddClaimBackToActiveCalendar = 'b507def2-1fff-451b-8d2e-2a3e4a7a3c1d',
  ClaimantAnnualStatusReportToKeepClaimOnGeneralContinuance = 'ecd683e9-4919-41b8-9b59-abd1e96c4eee',
  ClaimantPetitionForRehearing = '279586a8-cdae-47e2-99ad-4c92d78312e3',
  RespAnswerToClaimantComplaint = '3d57b703-9f59-49b3-b1f0-d67c255ea1c2',
  RespMotionForSummaryJudgment = 'a8998f68-27c2-48c9-932b-fd3a61dd43d6',
  RespMotionToDismiss = 'e4fcce62-02d6-4bc1-892b-18098672dd92',
  RespStipulationForAward = '163a864f-068a-4b9e-8fcb-e2f419b78eb0',
  RespDepartmentalReport = '20e871ba-0907-462f-9ee4-4edb637b661c',
  RespAffirmativeDefenses = '4c07c445-341c-4e95-a95e-ab5303010c43',
  RespMotionToPlaceClaimOnGeneralContinuance = '8af8c1d9-25b6-4451-9f19-e08b225c98e0',
  JointStipulationForAnAward = '94125355-cf12-4c54-bced-ba6e99da135b',
  JointStipulationToDismiss = '3d2a07d5-6396-449e-bb48-d5222c4d596d',
  RespChangeOfAddress = '1f702e12-13cc-453d-a010-342873e352f9',
  CCCourtTranscript = '89ae2f95-1657-4129-b4eb-fd86f930aa6b',
  ExhibitsFromTrial = 'ee638b2b-236e-44db-bfcd-a8c0cd5d90ad',
  CCOther = 'ce9363f8-bf9f-49ef-99f2-b03f6607e07e',
  ApplicationForWaiverOfFee = '9ecec6e1-0ece-4a99-9671-1c9aac9843e9',
  Application = '77929ab8-62b2-4876-b12b-0ae6324b2d88',
  AwardDLIRNoticeOfLienAndEconomicLossVendorRecipientInformationSheet = 'f082bafe-eac1-4c43-8c66-a75170688509',
  AwardNoPayDLIRNoticeOfRepaymentResponsibilities = 'd1151e72-2576-429e-acb3-1fb8aa1bcb6a',
  DenialDLIR = 'f4306612-1466-4026-98dd-b7bf24f85c02',
  SupplementalAwardDLIRNoticeOfLienAndEconomicLossVendorRecipientInformationSheet = '02620a57-e8a2-41ed-a989-ec1677bd5b73',
  SupplementalAwardNoPayDLIRNoticeOfRepaymentResponsibilities = '3f131eb5-42bc-49c1-8c67-38361fccb70f',
  SupplementalDenialDLIR = 'b219948e-4cf3-4765-b243-527a267ffb3e',
  AutoEmailRemandingDLToAGForAmendment = 'cc5c990d-6185-4600-8ece-47c83ff49997',
  AGAmendedAwardDLIRNoticeOfLienAndEconomicLossVendorRecipientInformationSheet = 'e50fa572-40e6-4980-88fe-64ddbade35ca',
  AGAmendedAwardNoPayDLIRNoticeOfPaymentResponsibilities = '5d9ad6cc-2211-468c-900e-48de394db3ad',
  AGAmendedDenialDLIR = '8935d108-a311-4fa0-a49f-76be471febf8',
  LettorToVendor = '38893f81-5a26-47ed-abaf-21d58e4e8702',
  AGAdministrativeActionDismissedForCausesUnrelatedToTheVictimization = 'a6075768-0c71-4b13-ab04-8321e078730d',
  AGAdministrativeActionVoluntaryDismissalByClaimantApplicationWithdrawn = '6d3c0a4e-e5b5-4317-9449-04629b3bc4fa',
  AGAdministrativeActionDuplicateClaim = 'a9b9cdff-5b5e-484b-885e-0ffb9471bef3',
  AGAdministrativeActionConsolidationOfClaims = 'e7723e98-9788-454f-8fbc-9eaba5c69199',
  AGAdministrativeActionGeneralContinuance = 'b825ee66-1197-41d2-9c6e-695e4f094b58',
  AGAdministrativeActionSubstitutionOfVictimAsClaimant = '42ff1d76-74cd-4143-a9ff-1df6bb4648bd',
  ClaimantsRequestToAppeal = '76140643-fa39-4f41-8c82-4858a27b3e7c',
  CommisionerHearingNotice = '9d18bbf3-a7a2-4c8e-b16a-c75d062a4655',
  CommisionerRecommendation = '77e84b12-ab74-495f-bbe7-cdce1d9cf393',
  OtherCommisionerOrder = 'c6ddc55d-9d43-4a32-8092-759285d30edf',
  CourtOrderAffirmedAfterHearing = '229eaa33-fb00-4d39-8d50-2d81d7975433',
  CourtOrderDeniedAfterHearing = '83e220fa-622a-4662-b939-6cec1d464d4c',
  CourtOrderRemandingToTheAGForFurtherAction = 'c7cd2c27-d248-4249-b182-5c658690214a',
  OtherCourtOrder = '7f750a21-7e5a-4372-a77c-20bca41eabf9',
  CVCourtTranscript = '5a1aa22e-27af-49bf-ad54-289c1214160b',
  ClaimantCorrespondence = '271a57dd-e95c-4ac9-b611-a79d055c8693',
  CVOther = '8063914c-485d-4a11-956c-45872ffee8b5',
  CertificateOfInnocence = 'a48fec93-a69e-43ff-8c97-60a54eb83f6c'
}

/**
 * Determination Category ID Enums
 * ToDo: 2/12/2025 - Need to ask Ryan to create something for this
 */
export enum DeterminationCategoryIdEnum {
  Denial = '70feba85-e558-4a86-a967-476ea29bf599',
  AwardNoPay = '8146cd05-a967-40f8-af19-83322f0b27a2',
  Award = 'f78511f1-7de4-43a6-b228-52518f17047c'
}
// --------------------------------------------------------------------------------------------

/**
 * The application title used as in all route titles.
 */
export const APP_TITLE = 'IL SOS';

/**
 * THe start month of the fiscal year.
 */
export const FISCAL_YEAR_START = 'July';

/**
 * The end month of the fiscal year.
 */
export const FISCAL_YEAR_END = 'June';

/**
 * The maximum number of counties the user is allowed to add
 * in the "Case Information" section.
 */
export const MAX_COUNTIES = 1;
/**
 * The max number of email addresses allowed for an admin user
 */
export const MAX_ADMIN_USER_EMAILS = 4;
/**
 * The max number of email addresses allowed for a non-admin user
 */
export const MAX_NON_ADMIN_USER_EMAILS = 2;

/**
 * The labels for the Claimant section of the Crime Victim form.
 */
export const CV_CLAIMANT_LABELS = {
  minors: {
    label: 'Number of minors (17 years old or younger) - If none, please enter zero',
    info: {
      title: 'Number of Minors',
      message: 'Number of Minors (17 years old or younger) and/or legally declared adult dependents served by this claim in addition to the claimant? If none, please enter zero.'
    }
  },
  age: 'Age at the time of the Crime',
  victimName: 'Enter Victim Name (if different from Claimant)',
};
// ---------------------------------------------------------------------------------------------------------------------
//                                                    New Filing Constants
// ---------------------------------------------------------------------------------------------------------------------
export const NEW_FILING_SECTIONS_ORDER = {
  CASE_INFORMATION: 1,
  CLAIMANT_INFORMATION: 2,
  DOCUMENT_INFORMATION: 3,
  FEE_INFORMATION: 4
}
export const NEW_FILING_SUCCESS_VERBIAGE = {
  title: 'Success!',
  bullets: [
    'Your filing was successfully submitted to the clerk of the court of claims.',
    'The clerk staff will soon review your filing to verify that it conforms to the court\'s filing rules.',
    'After the clerk reviews your filing, you will receive an email stating whether or not the clerk has accepted your filing.',
    'If you have any questions regarding the status of your filing, please get in touch with the clerk of the court.'
  ]
}

// ------------------------------------------------------------------------------------------------
export const REPORT_DESCRIPTIONS = {
  EMAILS: {
    title: 'Email Report',
    description: 'This report lists all generated and submitted emails for the selected date range. You may optionally select a user to filter the results further.'
  },
  FILED_CASES: {
    title: 'Filed Cases',
    description: 'This report lists all new actions for the selected date range. Please note that a Judge whose name does not appear in this report did not have cases assigned during the selected dates.'
  },
  CLAIM_STATUS: {
    title: 'Claim Status',
    description: 'This report returns the current status of the displayed cases.'
  },
  FISCAL_YEAR: {
    title: 'Fiscal Year',
    description: 'This report collects a list of cases closed during a fiscal year.'
  },
  VOUCHER_AWARDED: {
    title: 'Voucher Awarded',
    description: 'This report returns the awarded cases to assist with compiling the data provided to the Comptroller to process payments.'
  },
  CV_STATS: {
    title: 'Crime Victim Status',
    description: 'This report collects data needed for the Court\'s quarterly federal reporting.'
  },
  FEE_RECONCILIATION: {
    title: 'Fee Reconciliation Report',
    description: 'This report returns all successful payment transactions within the selected date range.'
  }
};
// ---------------------------------------------------------------------------------------------------------------------
//                                                    Fee Transaction Verbiage
// ---------------------------------------------------------------------------------------------------------------------
export const FEE_WAIVER_VERBIAGE = {
  description: "To request a fee waiver, you must fill out the \"Application for Waiver of Filing Fee for an Indigent Person\" and submit it as a supporting document along with the complaint. Please see the link to the form on the homepage.",
  link: {
    href: 'https://www.ilsos.gov/publications/courtclaimspub.html',
    title: 'Court of Claims - Publications/Forms',
  },
};

export const TRANSACTION_SUCCESS_VERBIAGE = {
  title: 'Success!',
  bullets: [
    'Your filing fees payment was successful.',
    'Your filing was successfully submitted to the clerk of the court.',
    "A court clerk will review your filing in order to verify it conforms to the court's filing rules.",
    'Upon review by the clerk of the court, you will receive an email stating whether or not the clerk has accepted your filing.',
    'If you have any questions in regard to the status of your filing, please contact the clerk of the court for assistance.'
  ]
};

export const TRANSACTION_CANCELLED_VERBIAGE = {
  title: 'Filing Not Submitted!',
  bullets: [
    'Your payment was cancelled.',
    'Your filing was NOT submitted to the clerk of the court.',
    'Please return to your filling to make any needed corrections and resubmit.',
    'If you have questions or need help with your filing, please contact the clerk of the court for assistance.',
  ]
}
/**
 * The start year for the CV year options.
 */
export const CV_YEAR_OPTIONS_START = 1975;

/**
 * Object that contains each section
 */
export const CV_STATS_SECTION_TITLES = {
  demographics: {
    applications: {
      index: 1,
      title: "Number of people for whom an application's made for victim compensation benefits during the reported period:"
    }
  },
}

/**
 * Regex pattern for a valid case number.
 */
export const CASE_NUMBER_REGEX = `^\\d{4}(CV|CC|cv|cc)\\d{4}$`;
/**
 * Regex pattern for a valid SSN or TIN.
 */
export const CASE_SSN_AND_TIN_REGEX = `^(?:(?!000|666|9\\d{2})\\d{3}[-\\s]?(?!00)\\d{2}[-\\s]?(?!0000)\\d{4}|(?!00)\\d{2}[-\\s]?\\d{7})$`
/**
 * Regex pattern for a valid attention line.
 */
export const CASE_ATTENTION_LINE_REGEX = `^(?!.* {2})[A-Za-z0-9 .-]{1,50}$`;
/**
 * Regex pattern for a valid phone number.
 */
export const CASE_PHONE_NUMBER_REGEX = `^(?:\\+1\\s?)?(?:\\(?\\d{3}\\)?[\\s.-]?)?\\d{3}[\\s.-]?\\d{4}$`;
/**
 * Regex pattern for a valid prisoner no. Allows for a single optional '#' at the start.
 */
export const CASE_PRISONER_NO_REGEX = `^#?[a-zA-Z0-9]+$`;
/**
 * Regex pattern for a valid warrant number.
 */
export const ALPHA_NUMERIC_REGEX = `^[a-zA-Z0-9]+$`;
/**
 * Maximum number of claimants allowed for a new case of type crime victim.
 */
export const NEW_CASE_CV_MAX_CLAIMANTS = 1;
/**
 * Maximum number of claimants allowed for a new case of type general.
 */
export const NEW_CASE_CC_MAX_CLAIMANTS = Infinity;
/**
 * Maximum number of values allowed to show in a column for participants.
 */
export const MAX_PARTICIPANTS_COLUMN_DISPLAY_COUNT = 2;
// ---------------------------------------------------------------------------------------------------------------------
//                                                    Queue Shit
// ---------------------------------------------------------------------------------------------------------------------
/**
 * Enum holding queue guids
 */
export enum QueueIdEnum {
  All = DEFAULT_GUID,
  ClerkQueue = 'ea511ac2-76fa-44f2-872b-669e4d80432a',
  CourtQueue = '26034923-cd0e-4ae6-8301-87bf83cc8884',
  CrimeVictimQueue = '7f41c7e4-81ea-4fcb-9cb5-f368c6b21bfc',
  FilingReviewQueue = 'c76f4d4b-1ef1-44c1-aa4a-ae884c6cc711',
}
/**
 * Enum holding queue descriptions
 */
export enum QueueDashboardCardDescriptions {
  ClerkQueue = 'View Work Items for clerk queue.',
  CrimeVictimQueue = 'View Work Item for crime victim queue.',
  CourtQueue = 'View Work Item for court queue.',
  FilingReviewQueue = 'View Work Item for filing review.',
}
/**
 * Default Mat Tooltop show delay (500ms)
 */
export const DEFAULT_MAT_TOOLTIP_DELAY = 500;
/**
 * Landing text for when no queues have been selected
 */
export const EMPTY_QUEUE_SELECTION_LANDING_TEXT = 'Please select a Queue to begin'
/**
 * Landing text for no case assignments
 */
export const EMPTY_CASE_ASSIGNMENTS_LANDING_TEXT = 'No Cases Currently Assigned';

/**
 * Enums for Disposition Ids.
 */
export enum DispositionIdEnum {
  ApprovedByCourt = "61dd42d4-fa06-45e6-bbd6-55660ce24fc7",
  ApprovedWithClericalCorrectionsByCourt = "38c0257c-7b68-48b1-80a0-df039f4f3731",
  RemandedToAGForAmmendment = "0cd66ac8-7a36-4564-a238-932c69b5c7a6"
}

// ---------------------------------------------------------------------------------------------------------------------
//                                                    Dashboard Links
// ---------------------------------------------------------------------------------------------------------------------
export interface DashboardLink {
  title: string;
  url: string;
  icon: string;
}

export const DASHBOARD_LINKS: DashboardLink[] = [
  {
    icon: 'fa-home',
    title: 'Clerk of the Court of Claims',
    url: 'https://www.ilsos.gov/departments/court-of-claims.html'
  },
  {
    icon: 'fa-list-ul',
    title: 'Illinois Court of Claims Statutes and Rules',
    url: 'https://www.ilsos.gov/content/dam/publications/pdf_publications/cc_pub4.pdf'
  },
];

// ---------------------------------------------------------------------------------------------------------------------
//                                                    Footer Links
// ---------------------------------------------------------------------------------------------------------------------
export interface FooterLink {
  title: string;
  url: string;
};

export const FOOTER_LINKS = [
  {
    title: 'Resources',
    url: 'https://www.fileandservexpress.com/illinois-agency/'
  } as FooterLink,
  {
    title: 'Home',
    url: 'https://www.ilsos.gov/departments/court-of-claims.html'
  } as FooterLink,
];
// ---------------------------------------------------------------------------------------------------------------------
//                                                    Timeout Constants
// ---------------------------------------------------------------------------------------------------------------------
/**
 * Amount of time when before idle countdown begins for non-admins (minutes x seconds)
 */
export const TIME_TO_IDLE_TIMEOUT_NON_ADMINS = 14 * 60; // 14 minutes
/**
 * Amount of time when before idle countdown begins for admins
 */
export const TIME_TO_IDLE_TIMEOUT_ADMINS = 60 * 60 * 10; // 10 Hours
/**
 * Amount of time to for idle countdown(minutes x seconds)
 */
export const IDLE_TIMEOUT = 1 * 60; // 1 Minute
/**
 * Amount of time to wait before logging out the user (milliseconds)
 */
export const TIMEOUT_LOGOUT_DELAY = 1500; // 1.5 seconds
// Debugging Values
// export const TIME_TO_IDLE_TIMEOUT_NON_ADMINS = 10; // 10 seconds
// export const IDLE_TIMEOUT = 10; // 10 Seconds

// ---------------------------------------------------------------------------------------------------------------------
//                                                    Column Length Constants
// ---------------------------------------------------------------------------------------------------------------------
/**
 * Max amount of characters to display before elipsis for filing review.
 */
export const FILINGS_MAX_DESCRIPTION_LENGTH = 100;
/**
 * Max amount of characters to display before elipsis for filing review.
 */
export const FILING_REVIEW_MAX_DESCRIPTION_LENGTH = 100;
/**
 * Max amount of characters to display before elipsis for filing review document menu option.
 */
export const FILING_REVIEW_DOCUMENT_DROPDOWN_MAX_LENGTH = 27;
/**
 * Max amount of characters to display before elipsis for docket search.
 */
export const DOCKET_SEARCH_MAX_DESCRIPTION_LENGTH = 100;
/**
 * Max amount of characters to display before elipsis for docket search document menu option.
 */
export const DOCKET_SEARCH_DOCUMENT_DROPDOWN_MAX_LENGTH = 27;


